<article *ngIf="!resend">
  <div *ngIf="!success && !error">
    <h1>Confirming</h1>
    <p>
      Please wait while we confirm your account...
    </p>
    <div class="v-center">
      <app-spinner></app-spinner>
    </div>
  </div>
  <div *ngIf="success">
    <h1>Confirmed!</h1>
    <p>
      Your account has been confirmed successfully and you have been logged in. 
    </p>

    <div class="actions">
      <a class="btn" (click)="close()" href="javascript:;">OK</a>
    </div>
  </div>

  <div *ngIf="error">
    <h1>Error</h1>
    <p>
      {{errorMessage}}
    </p>
    
    <div class="actions">
      <a class="btn" (click)="close()" href="javascript:;">Cancel</a>
      <a class="btn btn-primary" (click)="resend = true" href="javascript:;">Resend Email</a>
    </div>
  </div>
</article>
<article *ngIf="resend">
  <div *ngIf="!resending && !resent">
    <h1>Resend Confirmation Mail</h1>
    <p>Enter your email address below to resend the confirmation email.</p>
    <form (submit)="sendConfirmationMail(email)">

      <div class="form-group">
        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
          <div class="input-group-addon">
            <i class="fa fa-envelope-o" aria-hidden="true"></i>
          </div>
          <input type="text" class="form-control" id="email" placeholder="Email" name="email" [(ngModel)]="email" />
        </div>
      </div>

      <div class="actions">
        <a class="btn" (click)="close()" href="javascript:;">Cancel</a>
        <button class="btn btn-primary">Resend Email</button>
      </div>
    </form>
  </div>
  <div *ngIf="!resent && resending" class="v-center">
    <app-spinner></app-spinner>
  </div>
  <div *ngIf="resent">
    <h1>Check your email</h1>
    <p>The confirmation email has been resent. Check your mail to proceed.</p>
    <div class="actions">
      <a class="btn" (click)="close()" href="javascript:;">Cancel</a>
    </div>
  </div>
</article>